import { Component } from 'react';
import FormattedNumber from './FormattedNumber';
import NumberTypes from '../constants/NumberTypes';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedPercentage extends Component {
  render() {
    return /*#__PURE__*/_jsx(FormattedNumber, Object.assign({
      style: NumberTypes.PERCENTAGE
    }, this.props));
  }
}
FormattedPercentage.displayName = 'FormattedPercentage';
FormattedPercentage.contextType = I18nHMRContext;